export const useGoogleMapsLink = (address, unitNumber = '') => {
  const fullAddress = computed(() =>
    unitNumber ? `${unitNumber} ${address}` : address
  )

  const googleMapsLink = computed(() => {
    const encoded = encodeURIComponent(fullAddress.value)
    return `https://www.google.com/maps/search/?api=1&query=${encoded}`
  })

  return {
    fullAddress,
    googleMapsLink,
  }
}
